import SelectCustom from "@ui/select/selectCustom/SelectCustom";
import {useTranslation} from "react-i18next";


const SelectYears = ({onChange, currentYear, size = 'small'}) => {

    const {t} = useTranslation()

    const allYears = Array.from({length: 121}, (_, i) => {
        const value = new Date().getFullYear() - i;
        return {
            value,
            label:value
        }
    });

    return (
        <SelectCustom
            label={t('years')}
            size={size}
            value={currentYear}
            onChange={onChange}
            data={allYears}
        />
    )
}

export default SelectYears;